export const BLOCKTYPES = {
  HEADING: "heading",
  IMAGE: "image",
  DESCRIPTION: "description",
  CAROUSEL: "carousel",
  VIDEO: "video",
  LINK: "link",
  AUDIO: "audio",
  LOGO: "logo",
  TEXT: "text",
  SOCIAL: "social",
  BIO: "bio",
  CLIPBOAREDBUTTON: "clipboard",
  APPLINK: "appLink",
  LINKEDPAGE: "linkedPage",
  CONTACTFORM: "contactForm",
  CONTACTCARD: "contactCard",
  EMAILSUBSCRIBE: "emailSubscribe",
};
